export var ActionTypeTagColors = {
    PLAYER_SIT: "green",
    PLAYER_CHECK: "blue",
    PLAYER_BET: "orange",
    PLAYER_CALL: "purple",
    PLAYER_FOLD: "black",
    PLAYER_LOST: "red",
    PLAYER_WIN: "green",
    PLAYER_RAISE: "orange",
    PLAYER_ALLIN: "orange",
    BIG_BLINDS_POSTED: "blue",
    SMALL_BLINDS_POSTED: "purple",
    PLAYER_LEAVE: "red",
};
export var TransactionTabKeys = {
    Player: "player",
    Round: "round",
    Game: "game",
    Table: "table",
    Tenant: "tenant",
};
export var TransactionTabs = function (t) { return [
    {
        label: t("transactionManagement.tabs.round"),
        key: TransactionTabKeys.Round,
    },
    {
        label: t("transactionManagement.tabs.player"),
        key: TransactionTabKeys.Player,
    },
]; };
